<template>
  <v-card height="100%">
    map
  </v-card>
</template>

<script>
export default {
  data() {
    return {};
  },

  computed: {},

  components: {}
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/countries/country/Map.vue